import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const latestVersionId = (state: RootState) => state.pages.editor.scene.latestVersionId;

const getLatestVersionId = createSelector([latestVersionId], (versionId) => versionId);

export default getLatestVersionId;
